import { Trans, useTranslation } from 'react-i18next';
import { ArrowRightSmall } from '@peacecover/icon';
import { useGetBettieBalances } from '../../../domains/bettie/ui/hooks/useGetBettieBalances';
import { ReactComponent as GhostProfileIcon } from '../../../icons/thumbnail.ghost.profile.svg';

interface OpenNextPreviewCardProps {
  remainingPreviewsCount: number | null;
  speaker: string | null;
  onClick: () => void;
  disabled: boolean;
  isThread?: boolean;
}

const OpenNextPreviewCard = ({
  remainingPreviewsCount,
  speaker,
  onClick,
  disabled,
  isThread = true
}: OpenNextPreviewCardProps) => {
  const { t } = useTranslation();
  return isThread ? (
    <div className="text-pure-white px-[22px] py-[15px] flex items-start gap-[10px]">
      <GhostProfileIcon width={26} height={26} className="flex-shrink-0" />
      <div className="flex flex-col items-start gap-[5px] w-full">
        <div className="text-[14px] font-semibold leading-[17px] text-separator-light-1">
          {speaker ?? t('ScenePreviewDetail.anonymous')}
        </div>
        <OpenNextPreviewCardContent
          remainingPreviewsCount={remainingPreviewsCount}
          onClick={onClick}
          disabled={disabled}
        />
      </div>
    </div>
  ) : (
    <div className="px-[22px] pt-[8px]">
      <OpenNextPreviewCardContent
        remainingPreviewsCount={remainingPreviewsCount}
        onClick={onClick}
        disabled={disabled}
      />
    </div>
  );
};

export default OpenNextPreviewCard;

const OpenNextPreviewCardContent = ({
  remainingPreviewsCount,
  onClick,
  disabled
}: {
  remainingPreviewsCount: number | null;
  onClick: () => void;
  disabled: boolean;
}) => {
  const { t } = useTranslation();
  const { data: bettieBalances } = useGetBettieBalances();
  const currentHearts = bettieBalances?.bettiePoint?.balance ?? 0;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="bg-graident-multi-blue rounded-[16px] w-full p-[1px]"
    >
      <div className="px-[16px] py-[18px] bg-black rounded-[16px] flex items-center justify-between">
        <div className="flex flex-col items-start gap-[6px]">
          <div className="flex items-center gap-[6px]">
            <p className="text-[11px] font-medium leading-[13px] text-[#B2B2B2]">
              {t('ScenePreviewDetail.leftPreview', { count: remainingPreviewsCount ?? 0 })}
            </p>
            <div className="px-[4px] py-[2px] bg-white-opacity-200 rounded-[2px] text-[11px] font-medium leading-[13px] text-main-dark-2">
              {t('ScenePreviewDetail.currentHearts', { count: currentHearts })}
            </div>
          </div>
          <div className="flex items-center gap-[5px]">
            <img
              src="/assets/icons/graphic-3d/3D.like.png"
              alt="Like"
              className="w-[16px] h-[16px]"
            />
            <p className="text-[15px] font-bold leading-[18px] text-main-dark-1">
              <Trans
                i18nKey="ScenePreviewDetail.openNextPreview"
                values={{ count: 2 }}
                components={{
                  span: <span className="bg-graident-multi-blue bg-clip-text text-transparent" />
                }}
              />
            </p>
          </div>
        </div>
        <ArrowRightSmall size={17} className="text-pure-white" />
      </div>
    </button>
  );
};
